/**
 * Formats a date with the long form (e.g. 31.12.2000)
 * Use this if <FullDate /> is not applicable.
 *
 * @param intl intl object
 * @param date Date
 * @returns formatted date
 */export const formatDate=(intl,date)=>intl.formatDate(date,{day:'2-digit',month:'2-digit',year:'numeric'});/**
 * Formats an amount as euros in the active locale (e.g. 44,77 €).
 *
 * @param intl intl object
 * @param amount amount in euros
 * @returns formatted amount
 */export const formatCurrency=(intl,amount)=>intl.formatNumber(amount,{style:'currency',currency:'EUR'});export const translateGender=(intl,gender)=>intl.formatMessage({id:"gender ".concat(gender)})||intl.formatMessage({id:'gender unknown'});export const translateInsuranceType=(intl,insuranceType)=>intl.formatMessage({id:"insurance type ".concat(insuranceType)})||intl.formatMessage({id:'insurance type unknown'});export const translateBoolean=(intl,boolean)=>intl.formatMessage({id:"boolean ".concat(boolean)})||intl.formatMessage({id:'boolean unknown'});